module.exports = __webpack_public_path__ + "static/media/wk.95c672f7.svg";